<template>
  <div class="customer-page">
    <customer-header :name="nameRestaurant" prominent />
    <main class="customer-content home-content">
      <div v-if="logo && !logoFailed" class="restaurant-brand"><img :src="logo" :alt="'Logo de ' + nameRestaurant" @error="logoFailed = true" /></div>
      <restaurant-contact v-if="!loading && !error" :contact="contact" :expanded="contactExpanded" />
      <p v-if="loading" class="customer-state" role="status">Cargando la carta…</p>
      <div v-else-if="error" class="customer-state" role="alert">{{ error }} <el-button class="customer-retry" icon="el-icon-refresh" @click="loadData">Reintentar</el-button></div>
      <nav v-else class="home-links" aria-label="Carta y menús del restaurante">
        <router-link v-if="enableCarta" to="/carta" class="home-link">
          <img v-if="appearance.homeIcons.carta" :src="imageUrl(appearance.homeIcons.carta)" class="home-custom-icon" alt="" /><i v-else class="el-icon-notebook-2 home-icon" aria-hidden="true" /><div><h2>CARTA</h2></div><i class="el-icon-arrow-right" aria-hidden="true" />
        </router-link>
        <router-link v-if="enableMenu" to="/menu" class="home-link">
          <img v-if="appearance.homeIcons.menu" :src="imageUrl(appearance.homeIcons.menu)" class="home-custom-icon" alt="" /><i v-else class="el-icon-dish home-icon" aria-hidden="true" /><div><h2>MENÚS</h2></div><i class="el-icon-arrow-right" aria-hidden="true" />
        </router-link>
        <router-link v-for="group in featuredGroups" :key="group.id || group.key" :to="{ name: 'Grupo', params: { id: String(group.id || group.key) } }" class="home-link">
          <img v-if="group.iconImage || iconos[group.icon]" :src="group.iconImage ? imageUrl(group.iconImage) : iconos[group.icon].url" class="home-custom-icon" alt="" /><i v-else class="el-icon-fork-spoon home-icon" aria-hidden="true" /><div><h2>{{ group.group }}</h2></div><i class="el-icon-arrow-right" aria-hidden="true" />
        </router-link>
        <p v-if="!enableCarta && !enableMenu && !featuredGroups.length" class="customer-state">La carta no está disponible en este momento.</p>
      </nav>
      <p v-if="!loading && !error && appearance.footerMessage" class="home-footer-message">{{ appearance.footerMessage }}</p>
    </main>
  </div>
</template>
<script>
import * as api from "../api/request";
import CustomerHeader from "../components/CustomerHeader.vue";
import RestaurantContact from "../components/RestaurantContact.vue";
export default {
  components: { CustomerHeader, RestaurantContact },
  data() { return { appearance:{homeIcons:{},footerMessage:""}, iconos:[], nameRestaurant: "", logo: "", logoFailed: false, contact: {}, contactExpanded:false, enableCarta: false, enableMenu: false, data: [], loading: true, error: "" }; },
  computed: { featuredGroups() { return this.data.filter(group => group.enable === true && group.showOnHome === true); } },
  mounted() { this.loadData(); },
  methods: {
    imageUrl: api.imageUrl,
    async loadData() {
      this.loading = true; this.error = "";
      try {
        const data = await api.carta();
        this.appearance = data.appearance || {homeIcons:{},footerMessage:""};
        this.iconos = await api.getIconos();
        this.nameRestaurant = data.nameRestaurant;
        this.logo = api.imageUrl(data.logo);
        this.logoFailed = false;
        this.contact = data.contact || {};
        this.contactExpanded = data.contactExpanded === true;
        this.data = data.data || [];
        this.enableCarta = data.enableCarta === true;
        this.enableMenu = data.enableMenu === true;
      } catch (error) { this.error = ["PUBLICATION_DISABLED","LICENSE_EXPIRED","LICENSE_NOT_STARTED"].includes(error.response?.data?.code) ? error.response.data.error : "No se pudo cargar la carta. Comprueba tu conexión."; }
      finally { this.loading = false; }
    }
  }
};
</script>
<style scoped>
.home-custom-icon{width:58px;height:58px;flex:0 0 58px;object-fit:contain;border-radius:12px}.home-footer-message{white-space:pre-line;text-align:center;font-size:14px;line-height:1.6;margin:28px 0 0;padding:16px;border-radius:10px;background:rgba(255,255,255,.92);color:var(--brand);overflow-wrap:anywhere}
@media(max-width:400px){.home-custom-icon{width:44px;height:44px;flex-basis:44px}}
.home-content { padding-inline: max(16px, calc((100% - 748px) / 2)); padding-top: 12px; }
.restaurant-brand { display: flex; justify-content: center; margin: 12px 0 20px; }
.restaurant-brand img { max-width: min(240px, 80vw); max-height: 120px; object-fit: contain; }
.home-links { display: grid; grid-template-columns: 1fr; gap: 16px; }
.home-link { display: flex; align-items: center; gap: 18px; text-decoration: none; padding: 24px; background: white; border: 1px solid #dce4e3; border-radius: 16px; box-shadow: 0 4px 12px rgba(39,57,65,.04); }
.home-link div { flex: 1; min-width: 0; }
.home-link h2 { margin: 0; font-size: clamp(22px, 5vw, 30px); color: var(--brand); overflow-wrap: anywhere; }
.home-icon { display: flex; align-items: center; justify-content: center; font-size: 30px; color: var(--brand); background: var(--soft); width: 58px; height: 58px; border-radius: 14px; flex: 0 0 58px; }
.home-link:hover { border-color: #8a9c98; }
@media(max-width: 400px) { .home-link { padding: 18px; gap: 12px; } .home-icon { width: 44px; height: 44px; flex-basis: 44px; font-size: 24px; } }
</style>
